import { render, staticRenderFns } from "./SectionIntroductionReportPreview.vue?vue&type=template&id=33a8c9f9&scoped=true"
import script from "./SectionIntroductionReportPreview.vue?vue&type=script&lang=ts"
export * from "./SectionIntroductionReportPreview.vue?vue&type=script&lang=ts"
import style0 from "./SectionIntroductionReportPreview.vue?vue&type=style&index=0&id=33a8c9f9&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a8c9f9",
  null
  
)

export default component.exports